// extracted by mini-css-extract-plugin
export var chip = "_5s-0";
export var filterDropdown = "_5s-5";
export var filterItem = "_5s-6";
export var icon = "_5s-1";
export var removeButton = "_5s-3";
export var removeIcon = "_5s-4";
export var separator = "_5s-2";